import { render, staticRenderFns } from "./reduceHistory.vue?vue&type=template&id=77bbf68f&scoped=true"
import script from "./reduceHistory.vue?vue&type=script&lang=js"
export * from "./reduceHistory.vue?vue&type=script&lang=js"
import style0 from "./reduceHistory.vue?vue&type=style&index=0&id=77bbf68f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bbf68f",
  null
  
)

export default component.exports